<template>
  <div 
    :ref="'wrapper'" 
    :class="elem.classes" 
    @click.stop.self.prevent
  >
    <!-- <div style="width: 200px; background: #eee; left: 300px; position: relative;"> -->
      <!-- <pre style='font-size: 10px;'>resizeMode = {{ resizeMode }}</pre> -->
      <!-- <pre style='font-size: 10px;'>resizing = {{ resizing }}</pre> -->
      <!-- <pre style='font-size: 10px;'>minWidth, maxWidth = {{ minWidth }}, {{ maxWidth }}</pre> -->
      <!-- <pre style='font-size: 10px;'>minHeight, maxHeight = {{ minHeight }}, {{ maxHeight }}</pre> -->
      <!-- <pre style='font-size: 10px;'>ratio = {{ ratio }}</pre> -->
      <!-- <pre style='font-size: 10px;'>rectStart = {{ rectStart }}</pre> -->
      <!-- <pre style='font-size: 10px;'>rect = {{ rect }}</pre> -->
    <!-- </div> -->

    <div :class="elemDetail.classes" v-if="resizing" v-html="elemDetail.content" />
    <div v-if="_tools.includes('top')" ref="top" class="resize-dot top" @mouseover="initMouseOver('top')" @dblclick="onDblClick('top')"></div>
    <div v-if="_tools.includes('left')" ref="left" class="resize-dot left" @mouseover="initMouseOver('left')" @dblclick="onDblClick('left')"></div>
    <div v-if="_tools.includes('right')" ref="right" class="resize-dot right" @mouseover="initMouseOver('right')" @dblclick="onDblClick('right')"></div>
    <div v-if="_tools.includes('bottom')" ref="bottom" class="resize-dot bottom" @mouseover="initMouseOver('bottom')" @dblclick="onDblClick('bottom')"></div>
    <div v-if="_tools.includes('top_left')" ref="top_left" class="resize-dot top-left" @mouseover="initMouseOver('top_left')" @dblclick="onDblClick('top_left')"></div>
    <div v-if="_tools.includes('top_right')" ref="top_right" class="resize-dot top-right" @mouseover="initMouseOver('top_right')" @dblclick="onDblClick('top_right')"></div>
    <div v-if="_tools.includes('bottom_left')" ref="bottom_left" class="resize-dot bottom-left" @mouseover="initMouseOver('bottom_left')" @dblclick="onDblClick('bottom_left')"></div>
    <div v-if="_tools.includes('bottom_right')" ref="bottom_right" class="resize-dot bottom-right" @mouseover="initMouseOver('bottom_right')" @dblclick="onDblClick('bottom_right')"></div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: {
    tools: {
      default: undefined, // top, left, right, bottom, top_left, top_right, bottom_left, bottom_right
    },
    details: {
      default: undefined, // width, height
    },
    detailPosition: {
      default: 'top', // top, center, bottom
    },
    resizeMode: {
      default: 'normal', // normal, mirror (w or h size x2)
    },
    minWidth: {
      default: undefined,
    },
    maxWidth: {
      default: undefined,
    },
    minHeight: {
      default: undefined,
    },
    maxHeight: {
      default: undefined,
    },
  },
  data() {
    return {
      toolsAll: ['top', 'left', 'right', 'bottom', 'top_left', 'top_right', 'bottom_left', 'bottom_right'],
      detailsAll: ['width', 'height'],
      resizing: undefined,
      direction: undefined,
      ratio: undefined,
      rectStart: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      rect: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      posStart: {
        x: undefined,
        y: undefined,
      },
      posCurr: {
        x: undefined,
        y: undefined,
      },
    };
  },
  computed: {
    _tools() {
      if (this.tools && typeof this.tools === "string") return this.tools.split(',').map(item => item.trim());
      if (this.tools && Array.isArray(this.tools)) return this.tools;
      return this.toolsAll;
    },
    _details() {
      if (this.details && typeof this.details === "string") return this.details.split(',').map(item => item.trim());
      if (this.details && Array.isArray(this.details)) return this.details;
      return this.detailsAll;
    },
    // Elements
    elem() {
      return {
        classes: {
          'mwe-area': true,
          'mwe-resize-wrapper': true,
          'resizing': Boolean(this.resizing === true),
          'resized': Boolean(this.resizing === false),
        },
      };
    },
    elemDetail() {
      let contents = [];
      if (this._details.includes('width')) contents.push(`<span>W: ${this.rect.width}</span>`);
      if (this._details.includes('height')) contents.push(`<span>H: ${this.rect.height}</span>`);
      return {
        classes: {
          'mwe-resize-detail': true,
          'fs-rb-12': true,
          [this.detailPosition]: Boolean(this.detailPosition),
        },
        content: contents.join(', '),
      };
    },
  },
  methods: {
    initRect() {
      const $wrapper = this.$refs.wrapper;
      this.rectStart = {
        width: this.normalizePixelNum($wrapper.getBoundingClientRect().width),
        height: this.normalizePixelNum($wrapper.getBoundingClientRect().height),
        top: $wrapper.getBoundingClientRect().top,
        left: $wrapper.getBoundingClientRect().left,
        right: $wrapper.getBoundingClientRect().right,
        bottom: $wrapper.getBoundingClientRect().bottom,
      };
      this.rect = JSON.parse(JSON.stringify(this.rectStart));
      this.ratio = this.rect.width / this.rect.height;
    },
    resetRect() {
      this.rectStart = {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      };
      this.rect = JSON.parse(JSON.stringify(this.rectStart));
      this.ratio = undefined;
    },

    // Response
    getResponseEvent() {
      return {
        direction: this.direction,
        isFullWidth: Boolean(this.rect.width == this.maxWidth),
        isFullHeight: Boolean(this.rect.height == this.maxHeight),
      };
    },
    getResponseValue() {
      return {
        width: this.rect.width,
        height: this.rect.height,
      };
    },

    // Normalize
    normalizePixelNum(value) {
      return Math.round(parseFloat(value));
    },
    normalizeWidth(value) {
      if (this.minWidth) value = Math.max(this.minWidth, value);
      if (this.maxWidth) value = Math.min(this.maxWidth, value);
      return value;
    },
    normalizeHeight(value) {
      if (this.minHeight) value = Math.max(this.minHeight, value);
      if (this.maxHeight) value = Math.min(this.maxHeight, value);
      return value;
    },
    resize({ width = undefined, height = undefined }) {
      if (width) {
        height = parseInt(width * (this.rectStart.height / this.rectStart.width));
      } else {
        width = parseInt((this.rectStart.width / this.rectStart.height) * height);
      }

      let width2 = this.normalizeWidth(width);
      let height2 = this.normalizeHeight(height);

      if (width != width2) {
        return this.resize({ width: width2 });
      } 
      if (height != height2) {
        return this.resize({ height: height2 });
      }

      return {
        width: width,
        height: height,
      };
    },

    // Event
    onDblClick(direction) {
      direction;
      this.$emit('dbclick', {
        event: this.getResponseEvent(),
      });
      // switch (direction) {
      //   case 'top':
      //   case 'bottom': {
      //     if (this.rect.height < this.maxHeight && this.maxHeight !== undefined) {
      //       this.rect.height = this.maxHeight;
      //       this.emitInput();
      //       this.emitChange();
      //     }
      //   } break;
      //   case 'left':
      //   case 'right': {
      //     if (this.rect.width < this.maxWidth && this.maxWidth !== undefined) {
      //       this.rect.width = this.maxWidth;
      //       this.emitInput();
      //       this.emitChange();
      //     }
      //   } break;
      //   case 'top_left':
      //   case 'top_right':
      //   case 'bottom_left':
      //   case 'bottom_right': {
      //     let resize = this.resize({ width: this.maxWidth });
      //     let maxWidth = resize.width;
      //     let maxHeight = resize.height;

      //     if ((this.rect.width < maxWidth && maxWidth !== undefined) || (this.rect.height < maxHeight && maxHeight !== undefined)) {
      //       this.rect.width = this.maxWidth;
      //       this.rect.height = this.maxHeight;
      //       this.emitInput();
      //       this.emitChange();
      //     }
      //   } break;
      //   default:
      //     break;
      // }
    },
    emitInput() {
      this.$emit('input', {
        event: this.getResponseEvent(),
        value: this.getResponseValue(),
      });
    },
    emitChange() {
      this.$emit('change', {
        event: this.getResponseEvent(),
        value: this.getResponseValue(),
      });
    },

    initMouseOver(ref) {
      this.listenDrag(ref);
    },
    listenDrag(ref) {
      if (this.$refs[ref]) {
        this.$refs[ref].onmousedown = (e) => this.dragStart(e, ref);
      }
    },
    dragStart(e, ref) {
      this.direction = ref;
      
      e = e || window.event;
      e.preventDefault();

      // Resizing
      this.resizing = true;

      // Listener Event
      document.onmousemove = this.dragging;
      document.onmouseup = this.dragEnd;

      // Rect
      this.initRect();

      // POS
      this.posStart = this.posCurr = {
        x: e.clientX,
        y: e.clientY,
      }

      this.$emit('focus', this.getResponseEvent());
    },
    dragEnd() {
      // e = e || window.event;
      // e.preventDefault();

      let isEmitChange = !_.isEqual(this.rectStart, this.rect);

      // Resizing
      this.resizing = false;

      // Listener Event
      document.onmousemove = null;
      document.onmouseup = null;
      
      if (isEmitChange) {
        this.$emit('change', {
          event: this.getResponseEvent(),
          value: this.getResponseValue(),
        });
      }
      this.$emit('blur', this.getResponseEvent());
      // this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    dragging(e) {
      e = e || window.event;
      e.preventDefault();

      // let isEmitInput = true;

      // POS
      this.posCurr = {
        x: e.clientX,
        y: e.clientY,
      }

      // let diffval = 0;
      // const $wrapper = this.$refs.wrapper;
      // const width = $wrapper.getBoundingClientRect().width;
      // const height = $wrapper.getBoundingClientRect().height;
      // let w = 0;
      // let h = 0;

      switch (this.direction) {
        case "top": {
          if (this.posCurr.y == this.posStart.y) return; 

          let diffY = parseInt((this.posStart.y - this.posCurr.y));
          if (this.resizeMode == 'mirror') diffY = diffY * 2;
          let h = parseInt(this.rectStart.height) + parseInt(diffY);
          h = this.normalizeHeight(h);

          if (this.rect.height == h) return;
          this.rect.height = h;
        } 
        break;
        case "bottom": {
          if (this.posCurr.y == this.posStart.y) return; 

          let diffY = parseInt((this.posCurr.y - this.posStart.y));
          if (this.resizeMode == 'mirror') diffY = diffY * 2;
          let h = parseInt(this.rectStart.height) + parseInt(diffY);
          h = this.normalizeHeight(h);

          if (this.rect.height == h) return;
          this.rect.height = h;
        } 
        break;
        case "left": {
          if (this.posCurr.x == this.posStart.x) return; 

          let diffX = parseInt((this.posStart.x - this.posCurr.x));
          if (this.resizeMode == 'mirror') diffX = diffX * 2;
          let w = parseInt(this.rectStart.width) + parseInt(diffX);
          w = this.normalizeWidth(w);

          if (this.rect.width == w) return;
          this.rect.width = w;
        } 
        break;
        case "right": {
          if (this.posCurr.x == this.posStart.x) return; 

          let diffX = parseInt((this.posCurr.x - this.posStart.x));
          if (this.resizeMode == 'mirror') diffX = diffX * 2;
          let w = parseInt(this.rectStart.width) + parseInt(diffX);
          w = this.normalizeWidth(w);

          if (this.rect.width == w) return;
          this.rect.width = w;
        } 
        break;
        case "top_left": {
          if (this.posCurr.y == this.posStart.y && this.posCurr.x == this.posStart.x) return; 

          // Top
          let diffY = parseInt((this.posStart.y - this.posCurr.y));
          if (this.resizeMode == 'mirror') diffY = diffY * 2;
          // Left
          let diffX = parseInt((this.posStart.x - this.posCurr.x));
          if (this.resizeMode == 'mirror') diffX = diffX * 2;
          
          let w2, h2;
          if (Math.abs(diffY) > Math.abs(diffX)) {
            let h = parseInt(this.rectStart.height) + parseInt(diffY);
            let resize = this.resize({ height: h });
            w2 = resize.width;
            h2 = resize.height;
          } else {
            let w = parseInt(this.rectStart.width) + parseInt(diffX);
            let resize = this.resize({ width: w });
            w2 = resize.width;
            h2 = resize.height;
          }

          if (this.rect.width == w2 && this.rect.height == h2) return;
          this.rect.width = w2;
          this.rect.height = h2;

        } break;
        case "top_right": {
          if (this.posCurr.y == this.posStart.y && this.posCurr.x == this.posStart.x) return; 

          // Top
          let diffY = parseInt((this.posStart.y - this.posCurr.y));
          if (this.resizeMode == 'mirror') diffY = diffY * 2;
          // Right
          let diffX = parseInt((this.posCurr.x - this.posStart.x));
          if (this.resizeMode == 'mirror') diffX = diffX * 2;
          
          let w2, h2;
          if (Math.abs(diffY) > Math.abs(diffX)) {
            let h = parseInt(this.rectStart.height) + parseInt(diffY);
            let resize = this.resize({ height: h });
            w2 = resize.width;
            h2 = resize.height;
          } else {
            let w = parseInt(this.rectStart.width) + parseInt(diffX);
            let resize = this.resize({ width: w });
            w2 = resize.width;
            h2 = resize.height;
          }

          if (this.rect.width == w2 && this.rect.height == h2) return;
          this.rect.width = w2;
          this.rect.height = h2;

        } break;
        case "bottom_left": {
          if (this.posCurr.y == this.posStart.y && this.posCurr.x == this.posStart.x) return; 

          // Bottom
          let diffY = parseInt((this.posCurr.y - this.posStart.y));
          if (this.resizeMode == 'mirror') diffY = diffY * 2;
          // Left
          let diffX = parseInt((this.posStart.x - this.posCurr.x));
          if (this.resizeMode == 'mirror') diffX = diffX * 2;
          
          let w2, h2;
          if (Math.abs(diffY) > Math.abs(diffX)) {
            let h = parseInt(this.rectStart.height) + parseInt(diffY);
            let resize = this.resize({ height: h });
            w2 = resize.width;
            h2 = resize.height;
          } else {
            let w = parseInt(this.rectStart.width) + parseInt(diffX);
            let resize = this.resize({ width: w });
            w2 = resize.width;
            h2 = resize.height;
          }

          if (this.rect.width == w2 && this.rect.height == h2) return;
          this.rect.width = w2;
          this.rect.height = h2;

        } break;
        case "bottom_right": {
          if (this.posCurr.y == this.posStart.y && this.posCurr.x == this.posStart.x) return; 

          // Bottom
          let diffY = parseInt((this.posCurr.y - this.posStart.y));
          if (this.resizeMode == 'mirror') diffY = diffY * 2;
          // Right
          let diffX = parseInt((this.posCurr.x - this.posStart.x));
          if (this.resizeMode == 'mirror') diffX = diffX * 2;
          
          let w2, h2;
          if (Math.abs(diffY) > Math.abs(diffX)) {
            let h = parseInt(this.rectStart.height) + parseInt(diffY);
            let resize = this.resize({ height: h });
            w2 = resize.width;
            h2 = resize.height;
          } else {
            let w = parseInt(this.rectStart.width) + parseInt(diffX);
            let resize = this.resize({ width: w });
            w2 = resize.width;
            h2 = resize.height;
          }

          if (this.rect.width == w2 && this.rect.height == h2) return;
          this.rect.width = w2;
          this.rect.height = h2;

        } break;
        default:
          return;
      }

      // if (this.component.style.width < 200) {
      //   this.component.style.width = 200;
      //   if (this.direction == 'tl' || this.direction == 'tr' || this.direction == 'bl' || this.direction == 'br') {
      //     this.component.style.height = parseInt(this.component.style.width / this.ratio);
      //   } else {
      //     this.component.style.height = parseInt(height)
      //   }
      // } else if (this.component.style.height < 200) {
      //   this.component.style.height = 200;
      //   if (this.direction == 'tl' || this.direction == 'tr' || this.direction == 'bl' || this.direction == 'br') {
      //     this.component.style.width = parseInt(this.component.style.height * this.ratio);
      //   } else {
      //     this.component.style.width = parseInt(width)
      //   } 
      // } else if (this.component.style.width > this.widthMax) {
      //   this.component.style.width = this.widthMax
      // }

      // this.$emit("callbackResize");
      // if (isEmitInput) {
        this.$emit('input', {
          event: this.getResponseEvent(),
          value: this.getResponseValue(),
        });
      // }
    },
    detectOutOfFrame(e) {
      if (e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight)) {
        if (this.resizing) {
          this.dragEnd();
        }
      }
    },
  },
  mounted() {
    this.resetRect();
    this.resizing = undefined;
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
};
</script>

<style scoped>
.mwe-resize-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 10;
}

/* Detail */
.mwe-resize-detail {
  width: max-content;
  position: absolute;
  padding: 4px 8px;
  color: #FFFFFF;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}
.mwe-resize-detail.top {
  top: calc(-20px - 6px);
  left: 50%;
  transform: translateX(-50%);
}
.mwe-resize-detail.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mwe-resize-detail.bottom {
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
}

/* Dot */
.mwe-resize-wrapper .resize-dot {
  pointer-events: all;
  width: 8px;
  height: 8px;
  background-color: #ffffff;
  position: absolute;
  border: 1px solid #12A9FF;
}
.mwe-resize-wrapper .resize-dot.top {
  top: 0;
  left: 50%;
  margin-top: -4px;
  cursor: ns-resize;
}
.mwe-resize-wrapper .resize-dot.bottom {
  bottom: 0;
  left: 50%;
  margin-bottom: -4px;
  cursor: ns-resize;
}
.mwe-resize-wrapper .resize-dot.left {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  margin-left: -4px;
  cursor: ew-resize;
}
.mwe-resize-wrapper .resize-dot.right {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  margin-right: -4px;
  cursor: ew-resize;
}
.mwe-resize-wrapper .resize-dot.top-left {
  top: 0;
  left: 0;
  margin-top: -4px;
  margin-left: 0px;
  cursor: nwse-resize;
}
.mwe-resize-wrapper .resize-dot.top-right {
  top: 0;
  right: 0;
  margin-top: -4px;
  margin-right: -8px;
  cursor: nesw-resize;
}
.mwe-resize-wrapper .resize-dot.bottom-left {
  bottom: 0px;
  margin-bottom: -4px;
  margin-left: 0px;
  cursor: nesw-resize;
}
.mwe-resize-wrapper .resize-dot.bottom-right{
  bottom: 0;
  right: 0;
  margin-bottom: -4px;
  margin-right: -8px;
  cursor: nwse-resize;
}
</style>